export default __webpack_public_path__ + "static/media/close.022e5635.svg";